export enum FrequencyType {
  Auto = 'auto',
  Days = 'days',
  Week = 'weeks',
  Month = 'months',
  Year = 'years',
}
